export default __webpack_public_path__ + "static/media/IMG_00010.073e7b40.jpeg";